/**
 * @fileoverview Commercial name, legal name, and sector cascade for registration.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/CorporateIdentityNameFields
 */
import { ReactComponent as CompanyIcon } from "../../../assets/icons/CorporateIdentity/CompanyIcon.svg";
import SectorCascadeFields from "./SectorCascadeFields.jsx";

const CorporateIdentityNameFields = ({
  company,
  styles,
  form,
  getFieldValidation,
  missingRequiredFields,
}) => {
  const {
    t,
    isMobile,
    fieldValues,
    razonSocial,
    sectors,
    subSectors,
    branches,
    businessGroups,
    sectorEconomico,
    subSectorSCIAN,
    ramaSCIAN,
    grupoEmpresarial,
    getErrorMessage,
    handleValidatedFieldChange,
    handleRazonSocialChange,
    handleSectorEconomicoChange,
    handleSubSectorChange,
    handleRamaChange,
    handleGrupoEmpresarialChange,
  } = form;

  return (
    <div className={styles.inputRow}>
      {company && Object.hasOwn(company, "nombreComercial") && (
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.corporateIdentity.commercialNameLabel")}
            {missingRequiredFields &&
              Object.hasOwn(missingRequiredFields, "nombreComercial") && (
                <span className={styles.required}> *</span>
              )}
          </label>
          <div className={styles.inputWrapper}>
            <CompanyIcon className={styles.inputIcon} />
            <input
              type="text"
              className={`${styles.input} ${styles.inputWithIcon} ${
                getFieldValidation && getFieldValidation("nombreComercial")
                  ? styles.inputError
                  : ""
              }`}
              placeholder={t(
                "components.corporateIdentity.commercialNamePlaceholder",
              )}
              value={fieldValues.nombreComercial}
              onChange={(event) =>
                handleValidatedFieldChange(
                  "nombreComercial",
                  event.target.value,
                )
              }
              maxLength={100}
            />
          </div>
          {getErrorMessage("nombreComercial") && (
            <p className={styles.errorMessage}>
              {getErrorMessage("nombreComercial")}
            </p>
          )}
        </div>
      )}

      {company && Object.hasOwn(company, "razonSocial") && (
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.corporateIdentity.socialReasonLabel")}
            {missingRequiredFields &&
              Object.hasOwn(missingRequiredFields, "razonSocial") && (
                <span className={styles.required}> *</span>
              )}
          </label>
          <div className={styles.inputWrapper}>
            <CompanyIcon className={styles.inputIcon} />
            <input
              type="text"
              className={`${styles.input} ${styles.inputWithIcon} ${
                getFieldValidation && getFieldValidation("razonSocial")
                  ? styles.inputError
                  : ""
              }`}
              placeholder={t(
                "components.corporateIdentity.socialReasonPlaceholder",
              )}
              value={razonSocial}
              onChange={(event) => handleRazonSocialChange(event.target.value)}
            />
          </div>
        </div>
      )}

      <SectorCascadeFields
        company={company}
        sectors={sectors}
        subSectors={subSectors}
        branches={branches}
        businessGroups={businessGroups}
        sectorEconomico={sectorEconomico}
        subSectorSCIAN={subSectorSCIAN}
        ramaSCIAN={ramaSCIAN}
        grupoEmpresarial={grupoEmpresarial}
        onSectorEconomicoChange={handleSectorEconomicoChange}
        onSubSectorChange={handleSubSectorChange}
        onRamaChange={handleRamaChange}
        onGrupoEmpresarialChange={handleGrupoEmpresarialChange}
        getFieldValidation={getFieldValidation}
        missingRequiredFields={missingRequiredFields}
        isMobile={isMobile}
        t={t}
        styles={styles}
      />
    </div>
  );
};

export default CorporateIdentityNameFields;
